import { defineComponent, useSlots, computed, inject, ref, watch, createElementBlock, createCommentVNode, unref, openBlock, normalizeClass, createElementVNode, withDirectives, createVNode, vShow, withCtx, Fragment, renderList, createBlock, mergeProps, toDisplayString, renderSlot } from 'vue';
import { tabsInjectionKey } from './basler-components.es424.js';
import _sfc_main$1 from './basler-components.es95.js';
/* empty css                       */
import e from './basler-components.es432.js';
import ArrowLeft from './basler-components.es433.js';
import ArrowRight from './basler-components.es434.js';
import { useSlotContent } from './basler-components.es426.js';
import _sfc_main$2 from './basler-components.es81.js';
/* empty css                       */

const _hoisted_1 = { class: "tab-list__wrapper" };
const _hoisted_2 = ["aria-label"];
const _hoisted_3 = ["id", "aria-selected", "aria-controls", "tabindex", "onClick"];
const _hoisted_4 = { class: "tab-list__item-inner" };
const _hoisted_5 = ["src"];
const _hoisted_6 = { class: "tab-list__item-content" };
const _hoisted_7 = { class: "tab-list__item-title-wrapper" };
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = {
  key: 0,
  class: "tab-list__item-badge"
};
const _hoisted_10 = {
  key: 0,
  class: "tab-list__item-subtitle"
};
const _hoisted_11 = {
  key: 0,
  class: "tab-list__additional-content"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "TabList",
  props: {
    tabListIsFullwidth: { type: Boolean, default: false }
  },
  setup(__props) {
    const slots = useSlots();
    const { hasSlotContent } = useSlotContent();
    const hasDefaultSlotContent = computed(() => {
      return hasSlotContent(slots.default);
    });
    const { tabsState, selectTab, onElementKeydown } = inject(tabsInjectionKey) || {};
    const tabList = ref();
    const edgeLeftIsVisible = ref(true);
    const edgeRightIsVisible = ref(true);
    const onVisibilityChange = (data) => {
      edgeLeftIsVisible.value = data.edgeLeftIsVisible;
      edgeRightIsVisible.value = data.edgeRightIsVisible;
    };
    const activeTabIndex = computed(() => {
      if (!tabsState) {
        return 0;
      }
      return tabsState.tabs.findIndex((tab) => tab.isActive);
    });
    const nextTabId = computed(() => {
      if (!tabsState) {
        return "";
      }
      return tabsState.tabs[activeTabIndex.value + 1]?.computedId;
    });
    const prevTabId = computed(() => {
      if (!tabsState) {
        return "";
      }
      return tabsState.tabs[activeTabIndex.value - 1]?.computedId;
    });
    const hasPrevTab = computed(() => {
      if (!tabsState) {
        return false;
      }
      return activeTabIndex.value > 0;
    });
    const hasNextTab = computed(() => {
      if (!tabsState) {
        return false;
      }
      return activeTabIndex.value < tabsState.tabs.length - 1;
    });
    const goToPrevNextTab = (direction = "next") => {
      let desiredTabId = "";
      if (direction === "next") {
        desiredTabId = nextTabId.value;
      } else if (direction === "prev") {
        desiredTabId = prevTabId.value;
      }
      goToTab(desiredTabId);
    };
    const localTabsState = computed(() => {
      return tabsState;
    });
    const goToTab = (computedId) => {
      if (selectTab && computedId) {
        selectTab(computedId);
      }
    };
    const scrollTabIntoView = (tabId) => {
      const targetTab = tabList.value.querySelector(`[id="tab-item-${tabId}"]`);
      if (targetTab) {
        e(targetTab, {
          behavior: "smooth",
          inline: "center",
          scrollMode: "if-needed",
          boundary: tabList.value
        });
      }
    };
    watch(
      localTabsState,
      (newState) => {
        if (newState) {
          const activeTab = newState.tabs.find((tab) => tab.isActive);
          if (activeTab && activeTab.computedId) {
            scrollTabIntoView(activeTab.computedId);
          }
        }
      },
      { deep: true }
    );
    return (_ctx, _cache) => {
      return unref(tabsState) ? (openBlock(), createElementBlock("div", {
        key: 0,
        class: normalizeClass([
          "tab-list",
          {
            "is-fullwidth": _ctx.tabListIsFullwidth,
            "has-many-tabs": unref(tabsState).tabs.length > 3,
            "has-prev-tab": hasPrevTab.value,
            "has-next-tab": hasNextTab.value,
            "is-overflowing": !edgeLeftIsVisible.value || !edgeRightIsVisible.value
          }
        ]),
        ref_key: "tabList",
        ref: tabList
      }, [
        createElementVNode("div", _hoisted_1, [
          withDirectives(createElementVNode("button", {
            class: "tab-list__scroll-button tab-list__scroll-button--left",
            type: "button",
            "aria-label": "Go to previous tab",
            onClick: _cache[0] || (_cache[0] = ($event) => goToPrevNextTab("prev"))
          }, [
            createVNode(unref(ArrowLeft))
          ], 512), [
            [vShow, hasPrevTab.value]
          ]),
          createVNode(_sfc_main$1, { onVisibilityChange }, {
            default: withCtx(() => [
              createElementVNode("div", {
                role: "tablist",
                class: "tab-list__tabs",
                "aria-label": unref(tabsState).title ? unref(tabsState).title : void 0
              }, [
                (openBlock(true), createElementBlock(Fragment, null, renderList(unref(tabsState).tabs, (tab) => {
                  return openBlock(), createElementBlock("button", {
                    key: tab.computedId,
                    type: "button",
                    role: "tab",
                    id: `tab-item-${tab.computedId}`,
                    class: normalizeClass(["tab-list__item", { "has-img": tab?.imgSrc || tab?.icon }]),
                    "aria-selected": tab.isActive,
                    "aria-controls": `tab-panel-${tab.computedId}`,
                    tabindex: !tab.isActive ? "-1" : void 0,
                    onClick: ($event) => goToTab(tab.computedId),
                    onKeydown: _cache[1] || (_cache[1] = //@ts-ignore
                    (...args) => unref(onElementKeydown) && unref(onElementKeydown)(...args))
                  }, [
                    createElementVNode("span", _hoisted_4, [
                      tab.imgSrc ? (openBlock(), createElementBlock("img", {
                        key: 0,
                        src: tab.imgSrc,
                        class: "tab-list__item-image",
                        alt: ""
                      }, null, 8, _hoisted_5)) : tab.icon ? (openBlock(), createBlock(_sfc_main$2, mergeProps({
                        key: 1,
                        ref_for: true
                      }, tab.icon, { class: "tab-list__item-icon" }), null, 16)) : createCommentVNode("", true),
                      createElementVNode("span", _hoisted_6, [
                        createElementVNode("span", _hoisted_7, [
                          createElementVNode("span", {
                            class: "tab-list__item-title",
                            innerHTML: tab.title
                          }, null, 8, _hoisted_8),
                          tab.badge ? (openBlock(), createElementBlock("span", _hoisted_9, toDisplayString(tab.badge.text), 1)) : createCommentVNode("", true)
                        ]),
                        tab.subtitle ? (openBlock(), createElementBlock("span", _hoisted_10, toDisplayString(tab.subtitle), 1)) : createCommentVNode("", true)
                      ])
                    ])
                  ], 42, _hoisted_3);
                }), 128))
              ], 8, _hoisted_2)
            ]),
            _: 1
          }),
          withDirectives(createElementVNode("button", {
            class: "tab-list__scroll-button tab-list__scroll-button--right",
            type: "button",
            "aria-label": "Go to next tab",
            onClick: _cache[2] || (_cache[2] = ($event) => goToPrevNextTab("next"))
          }, [
            createVNode(unref(ArrowRight))
          ], 512), [
            [vShow, hasNextTab.value]
          ])
        ]),
        hasDefaultSlotContent.value ? (openBlock(), createElementBlock("div", _hoisted_11, [
          renderSlot(_ctx.$slots, "default")
        ])) : createCommentVNode("", true)
      ], 2)) : createCommentVNode("", true);
    };
  }
});

export { _sfc_main as default };
